module.exports = __webpack_public_path__ + "img/yyzz.7e60706d.png";